import { ca } from '@cian/analytics';

export const trackConsultantMotivationPopupShown = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'CallBack_popup_consultant_open',
    label: '',
  });
};

export const trackConsultantMotivationPopupClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'CallBack_popup_consultant_click',
    label: '',
  });
};
